export default class CampaignTableData {
  constructor(id, name, startDate, endDate, remainingDays, isActive) {
    this.id = id;
    this.name = name;
    this.startDate = startDate;
    this.endDate = endDate;
    this.remainingDays = remainingDays;
    this.isActive = isActive;
  }
}
